import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Badge from 'shopper/components/Badge';
import Button from 'shopper/components/Button';

import Image from 'components/Image';

import useSessionStorageState from 'hooks/useSessionStorageState';

import { sendEvent } from 'lib/gtag';
import { formatSponsorSessionStorageKey } from 'lib/sessionStorage';

const NavItem = ({
  bgUrl,
  className,
  gaEventAction,
  gaEventCategory,
  icon,
  imageProps = null,
  sameTab = true,
  text,
  unreadStatus = false,
  url,
}) => {
  const [isVisited, setVisited] = useSessionStorageState(
    formatSponsorSessionStorageKey(text)
  );

  const onClick = () => {
    if (unreadStatus) {
      setVisited(true);
    }

    if (bgUrl) {
      window.open(url, '_blank');
    }

    const category = gaEventCategory;
    const label = text;

    sendEvent({
      action: gaEventAction,
      category,
      label,
    });
    sendEvent({
      action: 'click_shortcut',
      category,
      label,
    });
  };

  if (!url) {
    return null;
  }

  const Item = (
    <Button
      as="a"
      className={twMerge(
        'relative flex flex-shrink-0 border-0 [&>span]:font-medium',
        className
      )}
      href={bgUrl || url}
      iconLeft={icon}
      rel={!sameTab && 'noopener noreferrer'}
      size="size4"
      target={sameTab ? '_self' : '_blank'}
      type="neutral-ghost"
      onClick={onClick}
    >
      {imageProps?.src && (
        <Image
          alt={imageProps?.alt ?? 'Logo do parceiro'}
          className="mr-2 size-4 rounded-1"
          height={16}
          src={imageProps.src}
          width={16}
          priority
        />
      )}
      {text}
      {unreadStatus && !isVisited && (
        <Badge
          className="absolute right-0 top-1"
          shape="dot"
          type="highlight"
        />
      )}
    </Button>
  );

  if (bgUrl || !sameTab) {
    return Item;
  }

  return (
    <NextLink href={url} prefetch={false} passHref>
      {Item}
    </NextLink>
  );
};

NavItem.propTypes = {
  bgUrl: PropTypes.string,
  gaEventAction: PropTypes.string.isRequired,
  gaEventCategory: PropTypes.string.isRequired,
  icon: PropTypes.shape(),
  imageProps: PropTypes.shape(),
  sameTab: PropTypes.bool,
  text: PropTypes.string.isRequired,
  unreadStatus: PropTypes.bool,
  url: PropTypes.string.isRequired,
};

export default NavItem;
